export const duplicateNumberErrorCode = ['ERR_00002'];
